import urls from "../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../utils/service";

export async function getEnquiry() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.Enquiry}?page=0&limit=25`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}